/**
 *
 * Overview
 *
 */

import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { ProgressBar, Button, Card } from 'react-bootstrap';
import { FormattedMessage } from 'react-intl';
import messages from './messages.js';
import Unplanned from './Unplanned.jsx';
import { NumbersSpan } from './NumbersSpan.js';
import { SLOT_ASSIGNED, SLOT_OPEN } from '../../constants.js';

function Overview(props) {
  const { meetingSet, meetingList } = props;
  const { timeslots } = meetingSet;
  const [show, setShow] = useState(false);
  const slotsOpen = timeslots.filter((o) => o.status === SLOT_OPEN).length;
  const slotsAllocated = timeslots.filter((o) => o.status === SLOT_ASSIGNED).length + slotsOpen;
  const countPlanned = meetingList.filter((m) => m.details.assigned).length;
  const required = meetingList.length;
  return (
    <Card className="border p-4">
      <h4 className="mt-0"><FormattedMessage {...messages.overview} /></h4>
      <ProgressBar now={100 * (countPlanned / required)} className="my-3" />
      <div>
        <NumbersSpan>{`${countPlanned} / ${required}`}</NumbersSpan>
        <span className="text-gray"><FormattedMessage {...messages.meetingsAssigned} /></span>
      </div>
      <div>
        <NumbersSpan>{`${slotsOpen}/${slotsAllocated}`}</NumbersSpan>
        <span className="text-gray"><FormattedMessage {...messages.slotsAvailable} /></span>
      </div>
      {countPlanned < required && (
        <div className="mt-3">
          <Button variant="light" onClick={() => setShow(true)}>
            <FormattedMessage {...messages.viewUnplanned} />
          </Button>
          <Unplanned show={show} meetingList={meetingList} onHide={() => setShow(false)} />
        </div>
      )}
    </Card>
  );
}

Overview.propTypes = {
  meetingSet: PropTypes.object,
  meetingList: PropTypes.array,
};

export default Overview;
